import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=9fae8cb6&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=9fae8cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fae8cb6",
  null
  
)

export default component.exports